import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { Switch } from './Switch';

export interface FilterBarProps {
  search: string;
  onSearch: (v: string) => void;
  children?: ReactNode;
  chips?: { label: string; onRemove: () => void }[];
  onClear?: () => void;
  follow?: { on: boolean; onChange: (v: boolean) => void };
}

export function FilterBar({ search, onSearch, children, chips, onClear, follow }: FilterBarProps) {
  return (
    <div
      style={{
        minHeight: 44,
        background: 'var(--panel)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
        padding: '6px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
      }}
    >
      <div
        style={{
          width: 260,
          height: 30,
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-sm)',
          background: 'var(--bg-2)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '0 10px',
        }}
      >
        <Icon name="search" size={16} color="var(--faint)" />
        <input
          value={search}
          placeholder="Cerca"
          onChange={(e) => onSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') onSearch('');
          }}
          style={{
            flex: 1,
            minWidth: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: 'var(--text)',
            font: '400 14px/20px var(--font-ui)',
          }}
        />
      </div>
      {children}
      {chips?.map((c) => (
        <span
          key={c.label}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            height: 22,
            padding: '0 8px',
            borderRadius: 'var(--r-full)',
            background: 'var(--accent-soft)',
            color: 'var(--accent)',
            font: '500 12px/16px var(--font-ui)',
          }}
        >
          {c.label}
          <button
            onClick={c.onRemove}
            aria-label="Rimuovi filtro"
            style={{
              border: 'none',
              background: 'none',
              color: 'inherit',
              cursor: 'pointer',
              display: 'grid',
              padding: 0,
            }}
          >
            <Icon name="x" size={12} />
          </button>
        </span>
      ))}
      {onClear && (
        <button
          onClick={onClear}
          className="t-small dim"
          style={{ border: 'none', background: 'none', cursor: 'pointer' }}
        >
          Azzera filtri
        </button>
      )}
      <span style={{ flex: 1 }} />
      {follow && (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <span className="t-caption dim">Segui in tempo reale</span>
          <Switch checked={follow.on} onChange={follow.onChange} />
        </span>
      )}
    </div>
  );
}
